exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2mqhiyYOt8NWgBDHtpgZxp{text-decoration:underline;cursor:text}._1nAD76b8Ry5-T_35RXWAKh{cursor:pointer}", ""]);
// Exports
exports.locals = {
	"n-editor-link": "_2mqhiyYOt8NWgBDHtpgZxp",
	"n-activeLink": "_1nAD76b8Ry5-T_35RXWAKh"
};